export default {
  base: {
    margin: '5px 0',
    padding: '0 5px 10px 5px',
    fontSize: '0.7em'
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageCaption/styles.js